<template>
  <router-view/>
</template>

<script>
  export default {
    
    mounted(){
      this.getCurrentLink()
    },
  
    data() {
      return {
        showModal: false,
      }
    },
    computed:{
      currentLink(){
      
      }
      
    },
    methods:{
      getCurrentLink(){
        return this.$router.currentRoute.name
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/wallet/BalanceBase.vue